// src/js/modules/mapSync.js

export function initMapSync(pano) {
  // 1. TOUR -> MAP: Send location data
  function syncMapWithTour() {
    if (pano.getVariableValue('map_vis') === false) {
      const mapContainer = document.getElementById('uoc-map-container');
      if (mapContainer) mapContainer.style.visibility = 'hidden';
      return;
    } else {
      const mapContainer = document.getElementById('uoc-map-container');
      if (mapContainer) mapContainer.style.visibility = 'inherit';
    }

    const nodeId = pano.getCurrentNode();
    const currentLatLng = pano.getNodeLatLng(nodeId);
    const zoom = 18;

    if (currentLatLng && typeof currentLatLng[0] === 'number' && typeof currentLatLng[1] === 'number') {
      const iframe = document.getElementById('uoc-map-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          action: 'centerMap',
          nodeId: nodeId,
          latlng: { lat: currentLatLng[0], lng: currentLatLng[1] },
          zoom: zoom
        }, '*');
      }
    }
  }

  // Attach the outgoing events
  pano.on('changenode', syncMapWithTour);
  pano.on('activatenode', syncMapWithTour);

  // 2. MAP -> TOUR: Listen for incoming instructions
  window.addEventListener('message', (event) => {
    if (!event.data) return;

    if (event.data.action === 'mapBounds') {
      const bounds = event.data.bounds;
      pano.changeViewLimit(bounds.south, bounds.west, bounds.north, bounds.east, -180, 180, 10, 80);
    }

    if (event.data.action === 'hideMap') {
      pano.setVariableValue('map_vis', false);
      if (event.data.url) {
        pano.openUrl(event.data.url, "_parent");
      }
    }
  });

  console.log("📍 Map Sync module initialized");
}